export class CampaignNotFoundError extends Error {
  constructor(public campaignId: string) {
    super(`Campaign with id ${campaignId} not found.`)
  }
}
